import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoTasks = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 320,
	height: 240,
	viewBox: "0 0 320 240",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	role: "img",
	"aria-labelledby": titleId,
	ref,
	...props,
	children: [
		title === undefined ? /* @__PURE__ */ _jsx("title", {
			id: titleId || "tasks-empty-state-title",
			children: "No tasks illustration"
		}) : title ? /* @__PURE__ */ _jsx("title", {
			id: titleId || "tasks-empty-state-title",
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("desc", {
			id: "tasks-empty-state-desc",
			children: "A clipboard with an empty checklist and a floating completed task chip."
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "tasks-bg",
			x1: 48,
			y1: 36,
			x2: 272,
			y2: 204,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--ui-background-color, #ffffff)" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "var(--ui-surface-color, #f4f6f8)"
			})]
		}), /* @__PURE__ */ _jsxs("filter", {
			id: "tasks-shadow",
			x: 56,
			y: 22,
			width: 208,
			height: 188,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 10 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 10 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.07 0 0 0 0 0.1 0 0 0 0 0.16 0 0 0 0.12 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_1_1"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_1_1",
					result: "shape"
				})
			]
		})] }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 76,
			cy: 68,
			r: 20,
			fill: "var(--ui-accent-color, #dbe7ff)",
			opacity: .7
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 252,
			cy: 58,
			r: 14,
			fill: "var(--ui-warning-color, #ffe7b8)",
			opacity: .9
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 250,
			cy: 184,
			r: 22,
			fill: "var(--ui-success-color, #d8f3dc)",
			opacity: .65
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M83 183C96 165 118 154 143 154H182C205 154 227 144 241 126",
			stroke: "var(--ui-border-color, #d7dce2)",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeDasharray: "7 9",
			opacity: .9
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#tasks-shadow)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 84,
					y: 42,
					width: 152,
					height: 148,
					rx: 20,
					fill: "url(#tasks-bg)",
					stroke: "var(--ui-border-color, #d7dce2)",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 128,
					y: 30,
					width: 64,
					height: 28,
					rx: 14,
					fill: "var(--ui-surface-color, #eef2f6)",
					stroke: "var(--ui-border-color, #d7dce2)",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 142,
					y: 39,
					width: 36,
					height: 10,
					rx: 5,
					fill: "var(--ui-text-secondary-color, #9aa4b2)",
					opacity: .45
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 108,
					y: 78,
					width: 18,
					height: 18,
					rx: 6,
					fill: "var(--ui-accent-color, #dbe7ff)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138,
					y: 81,
					width: 70,
					height: 6,
					rx: 3,
					fill: "var(--ui-text-color, #1f2937)",
					opacity: .2
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138,
					y: 91,
					width: 52,
					height: 6,
					rx: 3,
					fill: "var(--ui-text-color, #1f2937)",
					opacity: .1
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 108,
					y: 112,
					width: 18,
					height: 18,
					rx: 6,
					fill: "var(--ui-accent-color, #dbe7ff)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138,
					y: 115,
					width: 56,
					height: 6,
					rx: 3,
					fill: "var(--ui-text-color, #1f2937)",
					opacity: .14
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138,
					y: 125,
					width: 76,
					height: 6,
					rx: 3,
					fill: "var(--ui-text-color, #1f2937)",
					opacity: .08
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 108,
					y: 146,
					width: 18,
					height: 18,
					rx: 6,
					fill: "var(--ui-accent-color, #dbe7ff)"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138,
					y: 149,
					width: 64,
					height: 6,
					rx: 3,
					fill: "var(--ui-text-color, #1f2937)",
					opacity: .1
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 138,
					y: 159,
					width: 44,
					height: 6,
					rx: 3,
					fill: "var(--ui-text-color, #1f2937)",
					opacity: .06
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "rotate(-8 246 138)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 212,
					y: 118,
					width: 72,
					height: 40,
					rx: 14,
					fill: "var(--ui-background-color, #ffffff)",
					stroke: "var(--ui-border-color, #d7dce2)",
					strokeWidth: 2
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 230,
					cy: 138,
					r: 10,
					fill: "var(--ui-success-color, #d8f3dc)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M226 138L229 141L235 134",
					stroke: "var(--ui-success-foreground-color, #177245)",
					strokeWidth: 2.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 246,
					y: 132,
					width: 22,
					height: 6,
					rx: 3,
					fill: "var(--ui-text-color, #1f2937)",
					opacity: .22
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M72 178C72 178 76 174 82 174C88 174 92 178 92 178",
			stroke: "var(--ui-text-secondary-color, #9aa4b2)",
			strokeWidth: 3,
			strokeLinecap: "round",
			opacity: .8
		})
	]
});
const ForwardRef = forwardRef(SvgNoTasks);
export default ForwardRef;
